import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/icons/icon_enter.svg'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_svg_inline = _resolveDirective("svg-inline")!

  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["flex items-center group", { 'hover:opacity-80': _ctx.white }])
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["text-22px <xl:text-17px <lg:text-14px", {
        'group-hover:text-hex-6664D6': !_ctx.white,

        'text-white': _ctx.white,
      }])
    }, "В кабинет", 2),
    _withDirectives(_createElementVNode("img", {
      class: _normalizeClass([{
        'group-hover:fill-hex-6664D6': !_ctx.white,
        'fill-hex-ffffff': _ctx.white,
      }, "h-24px w-24px <xl:h-20px <xl:w-20px ml-15px <xl:ml-10px"]),
      src: _imports_0
    }, null, 2), [
      [_directive_svg_inline]
    ])
  ], 2))
}